// libs imports
import InputText from "../../../components/InputText";
import { fileSizeCheck, fileTypeCheck } from "../../../../validation";
import InputFileSingle from "../../../components/InputFile/InputFileSingle";

export const formFields = {
  id: "id",
  firstName: "firstName",
  surname: "surname",
  lastName: "lastName",
  email: "email",
  phone: "phone",
  avatarLink: "avatarLink",
  telegramNotificationsAvailability: "telegramNotificationsAvailability",
  readOnlyPersonalData: "readOnlyPersonalData",
};

export const telegramNotificationsAvailableRole = "Администратор системы";

export const getDefaultValues = (profileData) => {
  const {
    id,
    firstName,
    surname,
    lastName,
    email,
    phone,
    avatarLink,
    telegramNotificationsAvailability = false,
  } = profileData;
  return {
    id,
    firstName,
    surname,
    lastName,
    email,
    phone,
    avatarLink: {
      filesPrev: avatarLink ? [avatarLink] : [],
      filesToAdd: [],
      filesToDelete: [],
    },
    telegramNotificationsAvailability,
  };
};

export const AvatarFormItemConfig = [
  {
    name: formFields.avatarLink,
    type: "file",
    rules: {
      validate: {
        type: (files) => {
          const availableFileTypes = ["image/jpeg", "image/png"];
          return fileTypeCheck(
            files.filesToAdd,
            formFields.avatarLink,
            availableFileTypes,
          );
        },
        size: (files) => {
          const maxAvailableFileSize = 10; // MBs
          return fileSizeCheck(
            files.filesToAdd,
            formFields.avatarLink,
            maxAvailableFileSize,
          );
        },
      },
    },
    canDeleteFile: false,
    previewMode: "avatar",
    width: "auto",
    input: (props) => (<InputFileSingle {...props} accept={".png, .jpg, .jpeg"} />),
  },
];

export const EditProfileFormDataName = [
  {
    id: 3,
    name: formFields.lastName,
    label: "Фамилия",
    type: "text",
    width: "100%",
    rules: { required: true },
    input: (props) => <InputText {...props} />,
  },
  {
    id: 4,
    name: formFields.firstName,
    label: "Имя",
    type: "text",
    width: "100%",
    rules: { required: true },
    input: (props) => <InputText {...props} />,
  },
  {
    id: 5,
    name: formFields.surname,
    label: "Отчество",
    type: "text",
    width: "100%",
    rules: { required: true },
    input: (props) => <InputText {...props} />,
  },
];

export const EditProfileFormDataInfo = [
  {
    id: 6,
    name: formFields.phone,
    label: "Номер телефона",
    type: "text",
    width: "100%",
    rules: { required: true },
    input: (props) => <InputText {...props} />,
  },
];
